import { Post, Posts} from '../../PrivateComponents';
import Profile1 from '../../pages/user/profile2';
import ShopingCart from '../../pages/user/cart';

import CourseIndexPage from '../../pages/Course/index'
import AboutUs from '../../pages/content/about-us';
import HowBenefits from '../../pages/content/how-benefits';
import HowItWorks from '../../pages/content/how-it-works';
import TermsOfUse from '../../pages/content/terms-of-use';
import PrivacyPolicy from '../../pages/content/privacy-policy';
import ContactUs from '../../pages/content/contact-us';
import Help from '../../pages/content/help';
import FAQ from '../../pages/content/faq';


export default {
    Profile: {
        component: Profile1,
        path: '/profile'
    },
    Profile2: {
        component: Profile1,
        path: '/profile'
    },
    Cart: {
        component: ShopingCart,
        path: '/cart'
    },
    HowBenefits: {
        component: HowBenefits,
        path: '/how-we-benefits-you'
    },
    HowItWorks: {
        component: HowItWorks,
        path: '/how-it-works'
    },
    TermsOfUse: {
        component: TermsOfUse,
        path: '/terms-of-use'
    },
    PrivacyPolicy: {
        component: PrivacyPolicy,
        path: '/privacy-policy'
    },
    Help: {
        component: Help,
        path: '/help'
    },
    FAQ: {
        component: FAQ,
        path: '/faq'
    },
    AboutUs: {
        component: AboutUs,
        path: '/about-us'
    },
    ContactUs: {
        component: ContactUs,
        path: '/contact-us'
    },
    Posts: {
        component: Posts,
        path: '/profile/posts'
    },
    Post:{
        component: Post,
        path: '/profile/posts/:idPost'
    },
    Course:{
        component: CourseIndexPage,
        path: '/mycourses/'
    }
};